import { Component, OnInit } from '@angular/core';
import { ModalBase, notification, color, language } from 'curvy';
import { Task } from '@task-utils/types';
import { User } from '@task-modules/users';
import { TaskRoutes } from '@task-utils/routes';
import { ShortLocation } from '@task-modules/tickets';



type TempRequestType = Pick<Task.TempStaffRequest, 'title' | 'date_from' | 'date_to' | 'number_of_workers' | 'shifts' | 'location_id' | 'description'>;


@Component({
   selector: 'task-create-temp-staff-request-dialog',
   template: `
      <task-create-temp-staff-request (result)="handle_result($event)"></task-create-temp-staff-request>
   `
})
export class CreateTempStaffRequestDialog extends ModalBase<TempRequestType | Promise<TempRequestType>, boolean> implements OnInit {
   preventSoftClose = true;
   request: TempRequestType;

   ngOnInit() {
      if (this.injectedData instanceof Promise) {
         this.injectedData.then(res => {
            this.request = res || {
               title: "",
               date_from: "",
               date_to: "",
               number_of_workers: 1,
               shifts: "",
               location_id: null,
               description: "",
            }
         });
      }else {
         this.request = this.injectedData || {
            title: "",
            date_from: "",
            date_to: "",
            number_of_workers: 1,
            shifts: "",
            location_id: null,
            description: "",
         }
      }

    
   }

   handle_result(request: TempRequestType) {
      if (request == null) {
         this.submit(false);
         return;
      }

      this.request = request;
    
      TaskRoutes.temp_staff_requests.api_temp_staff_request_add(this.request).then(()=>{
         this.submit(true);
      }).catch(err=>{
         notification.show({
            message: language.translate("ERROR.GENERIC_TEXT"),
            title: language.translate("ERROR"),
            color: color.Variable.warn,
            icon: "error"
         })
         
      });
   }
}